import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import InputSimple, { phoneDecorator } from '@r1-frontend/ui-react/components/inputSimple';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';

const InputPhoneDecorator = phoneDecorator(InputSimple);

export const PriceBlock = styled.div`
    flex-direction: column;
    gap: 32px;
    margin-top: 15px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-top: 14px;
        gap: 14px;
    }
`;

export const FirstLine = styled.div`
    flex-direction: row;
`;

export const SecondLine = styled.div`
    gap: 12px;
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        gap: 8px;
    }
`;

export const PriceRow = styled.div`
    align-self: end;
    margin-left: 82px;
    margin-right: 61px;

    @media (min-width: ${wideBreakpoints.sDesktop}) {
        margin-left: 82px;
        margin-right: 61px;
    }

    @media (min-width: ${wideBreakpoints.laptop}) {
        margin-left: 39px;
        margin-right: 55px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        margin-left: 39px;
        margin-right: 55px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin: 0;
        margin-top: 8px;
    }
`;

export const PriceText = styled.div`
    ${FONTS.XXS};
    color: ${COLORS.middleGray};

    sup {
        top: 3px;
        font-size: 13px;
    }
`;

export const PriceContainer = styled.div`
    flex-direction: column;
    gap: 5px;

    @media (max-width: ${breakPoints.sDesktop}) {
        align-items: center;
    }

    @media (max-width: ${breakPoints.tablet}) {
        align-items: normal;
    }
`;

export const CurrentPrice = styled.div`
    ${FONTS.H4};

    @media (max-width: ${breakPoints.sDesktop}) {
        ${FONTS.H5};
    }

    @media (max-width: ${breakPoints.tablet}) {
        ${FONTS.H4};
    }
`;

export const InputPhone = styled(InputPhoneDecorator)`
    margin-bottom: 0;
    width: 283px;

    @media (min-width: ${wideBreakpoints.sDesktop}) {
        width: 283px;
    }

    @media (min-width: ${wideBreakpoints.laptop}) {
        width: 224px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: 224px;
    }
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
    }
`;

export const BannerButton = styled(BaseButton)`
    ${FONTS.S};
    height: fit-content;
    width: 220px;
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
    }
`;

export const ThrobberGlobal = styled.div`
    width: 100%;
    position: fixed;
    left: 0;
    top: 50%;
    z-index: 3;
`;
